'use strict';

/* For now, there's no reason to re-render the footer client-side, as we don't
   have any async behavior like the header. The only thing we have to do on the
   client is load the TRUSTe script. */
var script = global.document.createElement('script');
script.src = global.document.location.protocol + '//consent.truste.com/notice?domain=zillow.com&c=teconsent&text=true';
global.document.body.appendChild(script);


//////////////////
// WEBPACK FOOTER
// ./lib/client-assets/scripts/trustArc.js
// module id = 479
// module chunks = 6